import React from 'react';

import { IPlansListFields } from '../../../types/contentful';

import { PlanInfo } from './PlanInfo';
import { BlockContainer, Layout, Column } from '../Layout';
import { Text } from '../Text';

import { Wrapper, PlanColumn } from './styles';

interface Props extends IPlansListFields {
  sysId?: string;
}

export function PlansList({ plans, heading, sysId }: Props) {
  return (
    <BlockContainer
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-eltype="plan-list"
      data-blockid={sysId}
      data-testid="plansList"
    >
      <Layout>
        {!!heading && (
          <Column size={{ 0: 11 }} marginBottom="ml" justifyContent="center">
            <Text
              as="h2"
              fontSize={{
                0: 'h2_0',
                tablet: 'h2_tablet',
                desktop: 'h2_desktop'
              }}
              fontWeight="h2"
              colour="defaultText"
              textAlign={{ 0: 'left', tablet: 'center' }}
              data-elementid="plan-list-heading"
              dangerouslySetInnerHTML={{
                __html: heading || ''
              }}
            />
          </Column>
        )}
        <PlanColumn
          size={{ 0: 12, tablet: 11, max: 10 }}
          flexDirection="column"
        >
          <Wrapper role="list">
            {(plans || []).map(({ sys, fields }) => (
              <PlanInfo {...fields} key={sys?.id} />
            ))}
          </Wrapper>
        </PlanColumn>
      </Layout>
    </BlockContainer>
  );
}
